module.exports = __webpack_public_path__ + "images/mobile/init/member-visitor-cf97b000bec4bb6556e6b902bace7af6.png";